import MoviesSlider from '../MoviesSlider'
import './index.css'

const PrimeVideo = ({moviesList}) => {
  const actionMovies = moviesList.filter(movie => movie.categoryId === 'ACTION')
  const comedyMovies = moviesList.filter(movie => movie.categoryId === 'COMEDY')

  return (
    <div className="prime-video-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/prime-video-img.png"
        alt="prime video"
        className="prime-logo"
      />
      <h1 className="section-heading">Action Movies</h1>
      <MoviesSlider moviesList={actionMovies} testId="actionMoviesSlider" />
      <h1 className="section-heading">Comedy Movies</h1>
      <MoviesSlider moviesList={comedyMovies} testId="comedyMoviesSlider" />
    </div>
  )
}

export default PrimeVideo
